import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Event from '../../entities/event';
import Deadline from '../../entities/deadline';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteEvent(): boolean {
return true;
}
export function collectEventDeleteImpact(event: Event, context: DeleteImpactContext): void {
const key = 'event:' + event.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const deadlineEventIdImpact = workingRows<Deadline>('deadline', findAll<Deadline>('deadlines')).filter(deadlineRef => deadlineRef.eventId === event.id);
deadlineEventIdImpact.forEach(deadlineRef => addDeleteImpact(context, 'deadline:' + deadlineRef.id, 'deadlines'));}
export function deleteImpactEvent(event: Event): DeleteImpact {
const context = deleteImpactContext();
collectEventDeleteImpact(event, context);
return deleteImpactCounts(context);
}
export function deleteEvent(event: Event, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteEvent()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectEventDeleteImpact(event, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || event.id};
}
const key = 'event:' + event.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Deadline>('deadline', [...store.getState().deadlines.getMappingFor('eventId', event.id)]).filter(deadlineTemp => deadlineTemp.eventId === event.id).forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
if (_deadline.status === 'D') return;
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.eventId === event.id) {
_deadline.eventId = null;

}
_work.set('deadline:' + _deadline.id, _deadline);
dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline), 'deadline:' + _deadline.id);
});
const deleted = event.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.EventActions.removeEventQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceEvent(event: Event, replaceWith: Event, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = event.id;}
const _work = workingSet();
workingRows<Deadline>('deadline', [...store.getState().deadlines.getMappingFor('eventId', event.id)]).filter(deadlineTemp => deadlineTemp.eventId === event.id).forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
if (_deadline.status === 'D') return;
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.eventId === event.id) {
_deadline.eventId = replaceWith.id;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});



return event;
}
